var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { style: { height: _vm.screeHeight + "px" }, attrs: { id: "app" } },
    [
      !_vm.shouForget
        ? _c("div", { staticClass: "login-box" }, [
            _c("p", { staticClass: "login-title" }, [
              _vm._v("小程序后台系统登录"),
            ]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.loginForm.userName,
                  expression: "loginForm.userName",
                },
              ],
              staticClass: "login-input",
              attrs: {
                type: "text",
                placeholder: "请输入账号",
                minlength: "6",
                name: "user",
                maxlength: "20",
                autocomplete: "off",
              },
              domProps: { value: _vm.loginForm.userName },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.loginForm, "userName", $event.target.value)
                },
              },
            }),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.loginForm.password,
                  expression: "loginForm.password",
                },
              ],
              staticClass: "login-input",
              staticStyle: { padding: "0 15px", "box-sizing": "border-box" },
              attrs: {
                type: "password",
                placeholder: "请输入密码",
                autocomplete: "off",
              },
              domProps: { value: _vm.loginForm.password },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.loginForm, "password", $event.target.value)
                },
              },
            }),
            _c("div", { staticClass: "codebox" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.loginForm.code,
                    expression: "loginForm.code",
                  },
                ],
                staticClass: "login-input",
                staticStyle: { width: "268px", margin: "0" },
                attrs: {
                  type: "text",
                  placeholder: "请输入验证码",
                  autocomplete: "off",
                  name: "code",
                },
                domProps: { value: _vm.loginForm.code },
                on: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.loginFn.apply(null, arguments)
                  },
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.loginForm, "code", $event.target.value)
                  },
                },
              }),
              _c("div", { staticClass: "code" }, [
                _c("img", {
                  staticStyle: { width: "100%", height: "100%" },
                  attrs: { src: _vm.codeUrl, alt: "" },
                  on: { click: _vm.getCode },
                }),
              ]),
            ]),
            _c(
              "div",
              {
                staticClass: "codebox",
                staticStyle: { "margin-top": "56px", "font-size": "16px" },
              },
              [
                _c(
                  "el-checkbox",
                  {
                    staticStyle: { color: "#2d46ee", "font-size": "16px" },
                    on: { change: _vm.getChecked },
                    model: {
                      value: _vm.checkedPassword,
                      callback: function ($$v) {
                        _vm.checkedPassword = $$v
                      },
                      expression: "checkedPassword",
                    },
                  },
                  [_vm._v("记住密码")]
                ),
                _c(
                  "span",
                  {
                    staticStyle: { cursor: "pointer" },
                    on: {
                      click: function ($event) {
                        _vm.shouForget = true
                      },
                    },
                  },
                  [_vm._v("忘记密码？")]
                ),
              ],
              1
            ),
            _c("div", { staticClass: "login", on: { click: _vm.loginFn } }, [
              _vm._v("登录"),
            ]),
          ])
        : _c(
            "div",
            { staticClass: "login-box", staticStyle: { padding: "32px 60px" } },
            [
              _c(
                "p",
                {
                  staticClass: "login-title",
                  staticStyle: { "margin-bottom": "32px" },
                },
                [_vm._v("找回密码")]
              ),
              _c("p", { staticClass: "tips" }, [
                _vm._v(
                  " 注意：【找回密码】只有超级管理员才可使用，普通管理员修改密码需要找超级管理员在系统中修改！ "
                ),
              ]),
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  staticClass: "demo-ruleForm",
                  attrs: {
                    model: _vm.ruleForm,
                    rules: _vm.rules,
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "登录账号", prop: "username" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入登录账号" },
                        model: {
                          value: _vm.ruleForm.username,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "username", $$v)
                          },
                          expression: "ruleForm.username",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "手机号", prop: "phone" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入手机号" },
                        model: {
                          value: _vm.ruleForm.phone,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "phone", $$v)
                          },
                          expression: "ruleForm.phone",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "验证码", prop: "code" } },
                    [
                      [
                        _c("div", { staticStyle: { display: "flex" } }, [
                          _c(
                            "div",
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入验证码" },
                                model: {
                                  value: _vm.ruleForm.code,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "code", $$v)
                                  },
                                  expression: "ruleForm.code",
                                },
                              }),
                            ],
                            1
                          ),
                          !_vm.isCode
                            ? _c(
                                "div",
                                {
                                  staticClass: "get-code",
                                  on: {
                                    click: function ($event) {
                                      return _vm.getBackCode()
                                    },
                                  },
                                },
                                [_vm._v(" 获取验证码 ")]
                              )
                            : _vm._e(),
                          _vm.isCode
                            ? _c("div", { staticClass: "get-code1" }, [
                                _vm._v(
                                  " " + _vm._s(_vm.backTime) + "秒后重新获取 "
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ],
                    ],
                    2
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "新密码", prop: "password" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入新密码",
                          "show-password": "",
                        },
                        model: {
                          value: _vm.ruleForm.password,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "password", $$v)
                          },
                          expression: "ruleForm.password",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("p", { staticClass: "ipt-tips" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v("密码由英文、数字、符号组成，最少输入8位 "),
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: "确认密码", prop: "confirmPassword" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请再次输入密码",
                          "show-password": "",
                        },
                        model: {
                          value: _vm.ruleForm.confirmPassword,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "confirmPassword", $$v)
                          },
                          expression: "ruleForm.confirmPassword",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "login", on: { click: _vm.submitB } }, [
                _vm._v("确 认"),
              ]),
              _c(
                "div",
                {
                  staticStyle: {
                    "margin-left": "199px",
                    "line-height": "60px",
                    cursor: "pointer",
                  },
                  on: {
                    click: function ($event) {
                      _vm.shouForget = false
                    },
                  },
                },
                [_vm._v(" 账号密码登录 ")]
              ),
            ],
            1
          ),
      _vm._m(0),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "keep" }, [
      _c(
        "a",
        { attrs: { href: "https://beian.miit.gov.cn", target: "_blank" } },
        [_vm._v("粤ICP备17071851号")]
      ),
      _vm._v(" "),
      _c("span", [_vm._v("版权所有 © 广东九航商业发展有限公司")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }